'use client'

export default function HomeAmbientBackground() {
  return (
    <div className="pointer-events-none fixed inset-0 z-[-1]" aria-hidden>
      <div className="absolute top-1/4 left-1/2 h-[600px] w-[1000px] -translate-x-1/2 rounded-full bg-gradient-to-r from-purple-600/25 via-pink-600/20 to-blue-600/25 blur-[200px]" />
      <div className="absolute bottom-1/4 left-1/4 h-[500px] w-[500px] rounded-full bg-blue-600/15 blur-[150px]" />
      <div className="absolute right-1/4 bottom-1/3 h-[400px] w-[400px] rounded-full bg-purple-600/10 blur-[120px]" />
    </div>
  )
}
